import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../lib/cn.js';
const sizeClasses = {
    xs: 'text-sm font-semibold',
    sm: 'text-base font-semibold',
    md: 'text-lg font-semibold',
    lg: 'text-[length:var(--font-size-heading-lg)] font-semibold tracking-tight',
    xl: 'text-2xl font-semibold tracking-tight',
};
export const Heading = React.forwardRef(({ level, size = 'md', className, ...props }, ref) => {
    const Tag = `h${level}`;
    return (_jsx(Tag, { ref: ref, className: cn('text-[var(--color-text-primary)]', sizeClasses[size], className), ...props }));
});
Heading.displayName = 'Heading';
//# sourceMappingURL=heading.js.map